// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"821":"0391f5da","1526":"4b8205cf","1854":"5026bb1b","2663":"89e71a28","3268":"0e033726","4272":"984ea20d","4574":"7b7edd9f","5859":"224f532a","7534":"fb26f869","9341":"81e146c9"}[chunkId] + ".chunk.css";
};